// localStorage-backed multi-active-games service
const STORAGE_KEY = "activeGames"; // stores array of active game entries

function safeParse(json) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

function readAll() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  const parsed = safeParse(raw);
  return Array.isArray(parsed) ? parsed : [];
}

function writeAll(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    // simple notification
    window.dispatchEvent(new Event('storage'));
  } catch (e) {}
}

// migrate legacy single activeGame -> activeGames array
function migrateLegacy() {
  const legacyRaw = localStorage.getItem('activeGame');
  if (!legacyRaw) return;
  const legacy = safeParse(legacyRaw);
  if (!legacy) return;
  const list = readAll();
  // avoid duplicate migration
  if (!list.find(i => i.id === legacy.id)) {
    list.push(legacy);
    writeAll(list);
  }
  try { localStorage.removeItem('activeGame'); } catch (e) {}
}

export function createActiveGame(meta = {}) {
  migrateLegacy();
  const id = String(Date.now());
  const now = new Date().toISOString();
  const entry = {
    id,
    gameType: meta.gameType || "",
    displayName: meta.displayName || "",
    players: meta.players || [],
    snapshot: meta.snapshot || null,
    lastRound: meta.lastRound || null,
    updatedAt: now,
    route: meta.route || ""
  };
  const list = readAll();
  list.push(entry);
  writeAll(list);
  return id;
}

export function getActiveGames() {
  migrateLegacy();
  return readAll();
}

export function getActiveGame(id) {
  const list = readAll();
  return list.find(i => i.id === id) || null;
}

export function updateActiveGame(id, patch = {}) {
  const list = readAll();
  const idx = list.findIndex(i => i.id === id);
  if (idx === -1) return null;
  const now = new Date().toISOString();
  const updated = { ...list[idx], ...patch, updatedAt: now };
  list[idx] = updated;
  writeAll(list);
  return updated;
}

export function removeActiveGame(id) {
  const list = readAll();
  const filtered = list.filter(i => i.id !== id);
  writeAll(filtered);
}

export function hydrateForGame(id) {
  const active = getActiveGame(id);
  if (!active) return null;
  return {
    route: active.route,
    state: {
      resumed: true,
      activeGameId: active.id,
      activeGameSnapshot: active.snapshot || {
        players: active.players || [],
        currentRound: 1,
        completedRounds: []
      }
    }
  };
}

const activeGameService = {
  createActiveGame,
  getActiveGames,
  getActiveGame,
  updateActiveGame,
  removeActiveGame,
  hydrateForGame
};

export default activeGameService;
